import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SESSION_EXPIRED_EVENT, SESSION_RESTORED_EVENT } from '../utils/auth';
import './SessionExpiredBanner.css';

/**
 * Bannière globale de session expirée. Montée une seule fois à la racine de
 * l'app, elle écoute l'event `session-expired` (émis par `authFetch`/`apiFetch`
 * sur tout 401 backend) et propose deux actions claires :
 *   - « Se reconnecter » → route /compte (Sign in with Apple)
 *   - « Rafraîchir l'app » → reload complet (utile si l'app est trop ancienne,
 *     ex. build pré-#77 sans `authFetch` : cf. incident Lyon 2026-07).
 *
 * Remplace l'ancien comportement « écran vide / Données POS indisponibles » qui
 * ne disait rien à l'utilisateur sur la cause réelle (JWT absent/expiré).
 * L'event `session-restored` (émis après un re-login réussi) la masque.
 */
export function SessionExpiredBanner() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onExpired = () => setVisible(true);
    const onRestored = () => setVisible(false);
    window.addEventListener(SESSION_EXPIRED_EVENT, onExpired);
    window.addEventListener(SESSION_RESTORED_EVENT, onRestored);
    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, onExpired);
      window.removeEventListener(SESSION_RESTORED_EVENT, onRestored);
    };
  }, []);

  if (!visible) return null;

  return (
    <div className="session-expired-banner" role="alert">
      <div className="session-expired-inner">
        <p className="session-expired-msg">
          Session expirée. Reconnecte-toi ou mets à jour l'app si le problème persiste.
        </p>
        <div className="session-expired-actions">
          <button
            type="button"
            className="session-expired-btn session-expired-btn-primary"
            onClick={() => { setVisible(false); navigate('/compte'); }}
          >
            Se reconnecter
          </button>
          <button
            type="button"
            className="session-expired-btn session-expired-btn-ghost"
            onClick={() => window.location.reload()}
          >
            Rafraîchir l'app
          </button>
        </div>
      </div>
    </div>
  );
}
